<template>
  <div class="contact-card">
    <h3>Agende sua consulta</h3>
    <p>Email: <a href="mailto:anelisechagas.s@hotmail.com">anelisechagas.s@hotmail.com</a></p>
    <p>Instagram: <a href="https://instagram.com/anelisechagas" target="_blank">@anelisechagas</a></p>
    <p>LinkedIn: <a href="https://www.linkedin.com/in/anelise-chagas/" target="_blank">Perfil no LinkedIn</a></p>
  </div>
</template>

<style scoped>
.contact-card {
  margin-top: 40px;
  padding: 20px;
  border-radius: 14px;
  background: #eaf3f5;
  text-align: center;
}
.contact-card a {
  color: #2c5e6e;
  font-weight: 600;
  text-decoration: none;
}
</style>
